<template>
  <div v-if="summary">
    <Row class="mb-2">
      <Col cols="12" md="6">
        <div class="text-caption text--secondary">Pagos</div>
        <div class="text-h6">{{ summary.paid_count || 0 }}</div>
        <div class="text-body-2">{{ formatCurrency(summary.paid_amount || 0) }}</div>
      </Col>
      <Col cols="12" md="6">
        <div class="text-caption text--secondary">Pendentes</div>
        <div class="text-h6">{{ summary.pending_count || 0 }}</div>
        <div class="text-body-2">{{ formatCurrency(summary.pending_amount || 0) }}</div>
      </Col>
    </Row>
    <div v-if="summary.period_start" class="text-caption text--secondary">
      {{ formatDate(summary.period_start) }} — {{ formatDate(summary.period_end) }}
    </div>
  </div>
</template>

<script>
import { Row, Col } from '@/components/vuetify';
import { formatCurrency } from '@/utils';

export default {
  name: 'AdminDashboardPaymentPeriodSummary',
  components: { Row, Col },
  props: {
    summary: {
      type: Object,
      default: () => ({}),
    },
  },
  methods: {
    formatCurrency,
    formatDate(value) {
      if (!value) return '';

      const [year, month, day] = value.split('-');
      return `${day}/${month}/${year}`;
    },
  },
};
</script>
